import moment from 'moment'

import { AppConfig } from '../../../app-config'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'

export default function createMaldivesItinerary(
	request,
	onSuccess,
	onRej,
	router,
	lastLocation,
	locale,
) {
	const {
		departureAirportCode,
		departureAirport,
		departureDate,
		passengerConfiguration,
		arrivalAirportCode,
		nights,
		roomCode, // roomCode and mealCode is required only for credMaldives
		mealCode,
		nationality,
	} = request
	const nationalityVal =
		typeof nationality === 'string'
			? nationality.length > 0
				? nationality.toUpperCase()
				: null
			: ((nationality || {}).value || '').toUpperCase()
	let requestObj = {
		departureAirportCode: departureAirportCode || departureAirport,
		arrivalAirportCode: arrivalAirportCode
			? arrivalAirportCode
			: departureAirportCode || departureAirport,
		onwardArrivalAirportCode: request.regionCode
			? request.regionCode.toUpperCase()
			: 'MLE',
		returnDepartureAirportCode: request.regionCode
			? request.regionCode.toUpperCase()
			: 'MLE',
		departureDate: moment(departureDate).format('YYYY-MM-DD'),
		passengerConfiguration:
			passengerConfiguration || request.hotelGuestRoomConfigurations,
		nights,
		roomCode,
		mealCode,
		nationality: nationalityVal,
	}

	requestObj.leadSource = getLeadSource({
		router,
		lastLocation: lastLocation,
		itineraryId: '',
	})

	requestObj.leadSource.rc = request.regionCode || 'mle'
	requestObj.leadSource.prodType = 'speedboat'

	let url
	if (roomCode) {
		url = `${AppConfig.api_url}itinerary/islandResort/static/${request.regionCode}/${request.resortCode}?partner=CRED`
		requestObj.leadSource.prodType = 'CRED'
	} else {
		url = `${AppConfig.api_url}itinerary/islandResort/mle/${request.resortCode}`
	}

	triggerSimpleAjax({
		url,
		method: 'POST',
		body: requestObj,
		locale,
		onSuccess: response => {
			if (response.status === 'SUCCESS' && response.data) {
				onSuccess(response.data)
			} else {
				onRej('Failed: ' + JSON.stringify(response))
			}
		},
		onFailure: () => {
			onRej('Failed')
		},
	})
}
